export const PAGE_URLS = {
  LOGIN: '/login',
  AUTHORIZED: '/authorized',
  DASHBOARD: '/dashboard',
  VEHICLE_MANAGEMENT: '/arac-yonetimi',
  VEHICLES: '/araclar',
  ADD_VEHICLE: '/arac/ekle',
  EDIT_VEHICLE: '/arac/duzenle/:id',
  VEHICLE_GROUPS: '/arac-gruplari',
  ADD_VEHICLE_GROUPS: '/arac-grubu/ekle',
  EDIT_VEHICLE_GROUPS: '/arac-grubu/duzenle/:id',
  COURIERS: '/dagiticilar',
  COURIERS_AWAITING_APPROVAL: '/onay-bekleyen-dagiticilar',
  COURIER_APPLICATIONS: '/esnaf-kurye-basvurulari',
  USERS: '/kullanicilar',
  ADD_USER: '/kullanici/ekle',
  EDIT_USER: '/kullanici/duzenle/:id',
  FIRMS: '/firmalar',
  ADD_FIRM: '/firma/ekle',
  EDIT_FIRM: '/firma/duzenle/:id',
  REGIONS: '/bolgeler',
  ADD_REGION: '/bolge/ekle',
  EDIT_REGION: '/bolge/duzenle/:id',
  AUTH: '/yetki',
  CONTROL: '/kontrol',
  ORDERS: '/siparisler',
  ORDERS_PENDING_ACTIONS: '/aksiyon-bekleyen-siparisler',
  ORDERS_WAITING_TRANSFER: '/transfer-bekleyen-siparisler',
  ORDER_MAP_ANALYSIS: '/siparis-analizi',
  COURIER_PERFORMANCE_DASHBOARD: '/dagitici-performans-dashboard',
  LIVE_SCREEN: '/canli-izleme',
  END_OF_DAY_REPORT: '/gun-sonu-raporu',
  ORDER_ITEM_PROPERTIES: '/gramajli-urunler',
  PARTIAL_DELIVERY_APPROVAL: '/eksik-toplama-onayı',
  CANCELLED_ITEM_HISTORY_CONTROL: '/eksik-toplanan-urun-stok-kontrolu',
  ZONES: '/zonelar',
  ZONE_UPDATE: '/toplu-zone-guncelleme',
  SLOT_UPDATE: '/toplu-slot-guncelleme',
  COURIER_SHIFT_REPORT: '/dagitici-mesai-raporu',
  PARAMETER_SETTINGS: '/ayarlar',
  PARAMETER_DETAIL: '/parametre-detay',
  TEMPLATE_MANAGEMENT: '/sablon-yonetimi',
  ROUTING_VİEW: '/rota-listeleme',
  ROUTING_DETAIL: '/rota-detay',
  ROUTING_PLANNING: '/rota-planlama',
  TEMPLATE_ZONE_MATCHING: '/sablon-zone-eslestirme',
  SLOT_MONITORING: '/slot-izleme',
  COURIER_DISTANCE_REPORT: '/dagitici-mesafe-raporu',
  STORES: '/magazalar',
  ORDER_STATUS_REPORT: '/siparis-durum-raporu',
  ORDER_COURIER_MANAGEMENT: '/siparis-dagitici-yonetimi',
  PROGRESS_PAYMENT_TEMPLATES: '/hakedis-sablonlari',
  PROGRESS_PAYMENT_TEMPLATE_BY_STORE: '/magaza-eslesmeleri',
  STORE_GROUPS: '/subeler',
  BULK_DEFINITION_TRACING: '/toplu-tanım-takip',
  PROGRESS_PAYMENT_STATUS_TRACKING: '/hakedis-durum-takip',
  STORE_BASED_SECTION_SORT: '/magaza-bazli-reyon-siralama',
  WAITING_APPROVE_STORES: '/onay-bekleyen-magazalar',
  STOCK_SCREEN: '/stoklar',
  STOCK_TRANSACTION_SCREEN: '/stok-hareketleri',
  SETTINGS: '/ayarlar',
  MY_PROFILE: '/profil-ayarlarim',
  PERFORMANCE_INFO: '/performans-bilgileri',
  MASS_INFORMATION: '/toplu-bilgilendirme',
  STORE_TASK_PLAN: '/cizelge-sablonlari',
  STORE_TASK_GROUP: '/gorev-gruplari',
  STORE_TASK_TEMPLATES: '/gorevler',
};

export const PARENT_ROUTES = {
  VEHICLE_MANAGEMENT: '/arac-yonetimi',
  DEFINITIONS: '/tanimlar',
  ORDER_MANAGEMENT: '/siparis-yonetimi',
  LIVE_TRACKING: '/canli-izleme',
  REPORTS: '/raporlar',
  PRODUCT_MANAGEMENT: '/urun-yonetimi',
  ZONE_MANAGEMENT: '/zone-yonetimi',
  PARAMETERS: '/parametreler',
  SLOT_MANAGEMENT: '/slot-yonetimi',
  ROUTING_MANAGEMENT: '/rotalama-yonetimi',
  STOCK_MANAGEMENT: '/stok-yonetimi',
  PROGRESS_PAYMENT_SYSTEM: '/hakedis-sistemi',
  STORE_MANAGEMENT: '/magaza-yonetimi',
  STORE_TASK: '/magaza-cizelgeleme',
};

export const API_PATHS = {
  AUTH_TOKEN: '/api/auth/token',
  AUTH_INTROSPECT: '/api/auth/introspect',
  AUTH_LOGOUT: '/api/auth/revoke',
  FIRMS_SEARCH: '/api/firms/search',
  FIRMS: '/api/firms',
  VEHICLE_GROUPS_SEARCH: '/api/vehicle-groups/search',
  VEHICLE_GROUPS: '/api/vehicle-groups',
  USERS_SEARCH: '/api/users/search',
  ALL_USER: '/api/v3/users/search',
  USERS: '/api/users',
  USER_ROLES: '/api/users/roles',
  STORES_SEARCH: '/api/stores/search',
  COURIERS_SEARCH: '/api/couriers/search',
  COURIER_APPLICATION_LIST: '/api/courier-application/list',
  FILTERED_COURIER_APPLICATION_LIST: '/api/v2/courier-applications/search',
  COURIER_LOCATIONS: '/api/address',
  COURIERS_STATUS: '/api/couriers/approved-or-finance-approval',
  REGIONS_SEARCH: '/api/regions/search',
  REGIONS_SEARCH_V2: '/api/v2/regions/search',
  REGIONS_WITHOUT_STORE: '/api/regions-without-store/search',
  REGIONS: '/api/regions',
  COURIER_DOCUMENTS: '/api/couriers/[id]/documents',
  VEHICLES_SEARCH: '/api/vehicles/search',
  VEHICLES: '/api/vehicles',
  COURIERS_APPLICATIONS_STATUS_UPDATE: '/api/courier-application',
  VEHICLE_BRANDS_SEARCH: '/api/vehicle-brands/search',
  VEHICLE_MODELS_SEARCH: '/api/vehicle-models/search',
  ALL_USERS: '/api/users/search',
  ALL_STORES: '/api/stores/search',
  ALL_ZONES: '/api/zones/search',
  ALL_REGIONS: '/api/regions/search',
  ZONES_SEARCH: '/api/zones/search',
  ZONES_SEARCH_V2: '/api/v2/zones/search',
  WAITING_TRANSFER_ORDER: '/api/waiting-transfer-order',
  SLOT_DATES_SEARCH: '/api/slot-dates/search',
  COURIER_DASHBOARD: '/api/courier-dashboards',
  ORDERS_SEARCH: '/api/orders/search',
  ORDERS_DETAIL: '/api/orders/detail',
  ORDERS_LOCATIONS: '/api/orders/locations',
  REPORTS_END_OF_DAY: '/api/reports/end-of-day',
  COURIER_ASSIGNMENT: '/api/courier-assignments',
  DASHBOARD: '/api/dashboard',
  ORDER_ITEM_PROPERTIES_SEARCH: '/api/order-item-properties/search',
  ORDER_ITEM: '/api/order-item',
  ORDER_MAP: '/api/v1/map-filters',
  ORDER_ITEM_PROPERTIES: '/api/order-item-properties',
  GEO_RADAR_ZONES_SEARCH: '/api/georadar/zones/search',
  GEO_RADAR_ZONES: '/api/georadar/zones',
  GEORADAR_DIRECTORATE_SEARCH: '/api/georadar/directorate/search',
  GEOLOCATION: '/api/geolocation',
  REPORTS: '/api/v1/reports',
  COURIER_SHIFT_REPORT: '/api/reports',
  GEO_RADAR_ZONES_APPROVE: '/api/georadar/zones/approve',
  GEO_RADAR_ZONES_VERSION: '/api/georadar/zones/version',
  ZONE_DELIVERY_FEES: '/api/v1/zones/zone-delivery-fees/update-all-active',
  ZONE_MINIMUM_CART_AMOUNT: '/api/v1/zones/update-minimum-cart-amount',
  GEO_RADAR_RIVALS_BY_LOCATION: '/api/poi/rivals-by-location',
  GEO_RADAR_ZONE_MOVE: '/api/georadar/zones/move',
  GEO_RADAR_ZONE_REVERT: '/api/georadar/zones/revert',
  PARAMETER_SETTINGS: '/api/application-parameter',
  PARAMETER_DETAIL_SETTINGS: '/api/application-parameter/related-parameters',
  PARAMETER_DETAIL_SETTING: '/api/application-parameter/related-parameter',
  PARAMETER_SCOPES: '/api/application-parameter/scopes',
  STORES: '/api/stores',
  SLOT_TEMPLATES_SEARCH: '/api/slot-templates',
  SLOT_TEMPLATES_BY_ID: '/api/slot-templates/search',
  SLOT_TEMPLATES: '/api/slot-templates',
  ZONES: '/api/zones',
  SLOTS: '/api/slots',
  ORDERS: '/api/orders',
  COURIERS: '/api/couriers',
  ALL_DOCUMENTS: '/api/couriers/download-document-zip',
  ROUTES: '/api/routes',
  FIRM_PAYMENT_TYPE_SEARCH: '/api/firm-payment-type/search',
  COURIER_DISTANCE_REPORT: '/api/reports/distance-report',
  REPORT_EXPORT: '/api/reports/data',
  EXCEL_URL: '/api/excel-url',
  IMPORT_FILE: '/api/import/data',
  STORES_SEARCH_V2: '/api/v2/stores/search',
  STORES_SEARCH_ACTIVE_ROLES_V2: '/api/v2/stores/search/active-roles',
  STORES_V2: '/api/v2/stores',
  SLOT_ZONE: '/api/slots',
  ZONE_SLOT_TEMPLATES: '/api/zone-slot-templates',
  COURIERS_FILTER: '/api/couriers/filter',
  ROUTING_SEARCH: '/api/route-task/search',
  ROUTING_TASK: '/api/route-task',
  REASON_TYPES: '/api/reasons/type',
  RE_ROUTES: '/api/re-routes',
  IS_RE_ROUTING_REQ: '/api/routes/is-re-routing-required',
  TRANSFER_ORDERS_COURIER:
    '/api/courier-assignments/transfer-orders-for-courier',
  ISOCHRONE_ZONE: '/api/isochrones',
  ORDER_STATUS_REPORT: '/api/reports/order-status-report',
  APPROVE_ROUTES: '/api/v1/routes/approve',
  SLOTS_OF_ZONE: '/api/slots/zone',
  SHIPMENT_TYPES: '/api/shipment-types',
  PAYMENT_TYPES: '/api/payment-types',
  DATA_IMPORT: '/api/datas/import',
  PROGRESS_PAYMENT: '/api/progress-payment-templates',
  STORE_GROUPS_SEARCH: '/api/v2/regions/with-manager',
  STORES_OF_STORE_GROUP: '/api/v2/stores/region',
  DATA_TEMPLATE: '/api/datas/template',
  PROGRESS_PAYMENT_TEMPLATES: '/api/progress-payment-templates',
  PROGRESS_PAYMENTS: '/api/progress-payments',
  PROGRESS_PAYMENT_DETAILS: '/api/progress-payment-details',
  PROGRESS_PAYMENT_ORDERS: '/api/progress-payment-orders',
  COURIER_DELIVERY_EFFICIENCY_OTIF_MONTHLY:
    '/api/v1/reports/couriers/deliver-efficiency-otif/monthly',
  COURIER_DELIVERY_EFFICIENCY_OTIF_DAILY:
    '/api/v1/reports/couriers/deliver-efficiency-otif/daily',
  CLOSED_DATES: '/api/store-closed-dates',
  BULK_DEFINITIONS_TRACES: '/api/datas/traces',
  STORE_CATEGORY_RANKING: '/api/store-category-rankings',
  EXCEL_URL_STORE: '/api/excel-url/store-template',
  STOCK_INVENTORY: '/api/v1/inventory',
  IMPORT_STORE_DATA: '/api/data/import-file',
  GPS_LOCATIONS: '/api/locations',
  ZONE_MOVE: '/api/v2/zones/move',
  ZONES_V2: '/api/v2/zones',
  ORDERS_TRANSFER: '/api/orders/transfer',
  ZONES_WITH_SLOT: '/api/v2/zones/store',
  CANCELLED_ITEM_HISTORY: '/api/cancelled-item-history',
  ORDER_HISTORY: '/api/order-history/search',
  PASSIVE_USER_ROLE_STATUS: '/api/users/passive-user-role-status',
  UPDATE_PASSWORD: '/api/users/update-password',
  NOTIFICATION_DEFINITIONS: '/api/notification-definitions',
  METRIC_DEFINITIONS: '/api/metric-definitions',
  ALL_CITIES: '/api/cities/search',
  STORE_PROGRESS_PAYMENTS: '/api/store-progress-payments',
  TASK_PLAN_LIST: '/api/v1/task-plans',
  TASK_GROUP_LIST: '/api/v1/task-groups',
  TASK_TEMPLATES_LIST: '/api/v1/task-templates',
  PERIODS_LIST: '/api/v1/periods',
  STORE_TYPES: '/api/v1/store-types',
  ROLE_TYPES: '/api/v1/roles',
  STORE_COURIER_SOURCES: '/api/store-courier-sources',
  COURIER_SOURCES: '/api/courier-sources',
  PROGRESS_PAYMENT_TEMPLATE_BY_STORE_SEARCH: '/api/v1/progress-payment-template-by-store/search',
  INVOICE_APPROVAL_APPROVE: '/api/v1/invoice-approval/approve',
};

export const AUTHORIZED_REDIRECT_URL = '[origin]/authorized';
export const LOGIN_PAGE_REDIRECT_URL =
  '[AUTH_UI_ADDRESS]?response_type=code&client_id=routi&scope=cookie&redirect_uri=[origin]%2Fauthorized';

export const DASHBOARD_REPORT_PATHS = {
  DIRECTORATE: [
    '/directorate/collection-efficiency',
    '/directorate/delivery-efficiency',
    '/directorate/cancellation-and-return-rate',
    '/directorate/cancellation-rate',
    '/directorate/return-rate',
    '/directorate/complaint-rate',
  ],
  REGION: [
    '/region/collection-efficiency',
    '/region/delivery-efficiency',
    '/region/cancellation-and-return-rate',
    '/region/cancellation-rate',
    '/region/return-rate',
    '/region/directorate/complaint-rate',
  ],
  STORE: [
    '/collection-efficiency',
    '/delivery-efficiency',
    '/cancellation-and-return-rate',
    '/cancellation-rate',
    '/return-rate',
  ],
};
